import React, { useState } from "react";
import Navbar from "../../components/Navbar";
import { useParams, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { RootState } from "../../app/store";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import Link from "@mui/material/Link";
import { useOptions } from "../../hooks/useOptions";
import RoleBasedComponent from "../../components/RoleBasedComponent";
import ManageProductPricingSection from "../../sections/manage/ManageProductPricingSection";
import ManageReservationsSection from "../../sections/manage/ManageReservationsSection";
import ManageProductOptionSection from "../../sections/manage/ManageProductOptionSection";
import ManageMeetingPointSection from "../../sections/manage/ManageMeetingPointSection";
import ManageAddonsSection from "../../sections/manage/ManageAddonsSection";
import ManageCancelationPolicySection from "../../sections/manage/ManageCancelationPolicySection";
import ManageAvailabilitySection from "../../sections/manage/ManageAvailabilitySection";
import ManageScheduleSection from "../../sections/manage/ManageScheduleSection";
import ManagePricingCategoriesSection from "../../sections/manage/ManagePricingCategoriesSection";
import ManageCapacitySection from "../../sections/manage/ManageCapacitySection";

export default function ProductOptionsDetailPage() {
  const params = useParams();
  const location = useLocation();
  const { id: paramId, optionId } = params;

  // Get editPackageId from edit reducer
  const { id: editPackageId } = useSelector((state: RootState) => state.edit);

  // Use editPackageId for the breadcrumb link
  const packageIdForBreadcrumb =
    editPackageId || paramId || location.state?.packageId;

  const { updateOption } = useOptions();

  const [submitLoading, setSubmitLoading] = useState(false);

  // Try to get option from navigation state first
  const optionFromState = location.state?.option;

  // Fallback: get from Redux store if available
  const packageData = useSelector((state: RootState) => state.tour.packageData);
  const optionFromRedux = packageData?.optionIds?.find(
    (opt: any) => opt._id === optionId
  );

  const option = optionFromState || optionFromRedux;

  const handleSubmit = async () => {
    if (!option || !optionId) return;
    setSubmitLoading(true);
    try {
      await updateOption(optionId, option);
    } catch (error) {
      console.error("Error updating option:", error);
    } finally {
      setSubmitLoading(false);
    }
  };

  return (
    <div className="font-main">
      <Navbar />
      <div className="flex flex-col min-h-screen bg-gray-100">
        <div className="w-full max-w-[1308px] max-xl:px-4 my-10 mx-auto">
          <>
            <div className="mb-4 flex flex-col sm:flex-row justify-between items-center w-full">
              <div className="w-full">
                <Breadcrumbs aria-label="breadcrumb">
                  <Link
                    underline="hover"
                    style={{ color: "black" }}
                    href="/manage/product"
                  >
                    Products
                  </Link>
                  <Link
                    underline="hover"
                    style={{ color: "black" }}
                    href={
                      packageIdForBreadcrumb
                        ? `/manage/product/${packageIdForBreadcrumb}`
                        : "#"
                    }
                  >
                    {packageData?.title || "Product Detail"}
                  </Link>
                  <span className="text-primary">
                    {option?.title || "Option Detail"}
                  </span>
                </Breadcrumbs>
              </div>
              <div className="w-full flex justify-end">
                <RoleBasedComponent allowedRoles={["supplier"]}>
                  <button
                    className="bg-primary text-white rounded-lg text-sm md:text-lg font-bold py-2.5 w-full max-w-[164px]"
                    onClick={handleSubmit}
                    disabled={submitLoading}
                  >
                    {submitLoading ? "Submitting..." : "Submit"}
                  </button>
                </RoleBasedComponent>
              </div>
            </div>
            {!option ? (
              <div className="text-center text-gray-500 py-20">
                Option not found.
              </div>
            ) : (
              <div className="max-w-[1308px] mx-auto">
                <ManageProductOptionSection optionData={option} />
                <hr className="my-4 border-[#BCC7D366]" />
                <ManageReservationsSection optionData={option} />
                <hr className="my-4 border-[#BCC7D366]" />
                <ManageMeetingPointSection optionData={option} />
                <hr className="my-4 border-[#BCC7D366]" />
                <ManageAvailabilitySection optionData={option} />
                <hr className="my-4 border-[#BCC7D366]" />
                <ManageScheduleSection optionData={option} />
                <hr className="my-4 border-[#BCC7D366]" />
                <ManagePricingCategoriesSection optionData={option} />
                <hr className="my-4 border-[#BCC7D366]" />
                <ManageCapacitySection optionData={option} />
                <hr className="my-4 border-[#BCC7D366]" />
                <ManageProductPricingSection optionData={option} />
                <hr className="my-4 border-[#BCC7D366]" />
                <ManageCancelationPolicySection optionData={option} />
                <hr className="my-4 border-[#BCC7D366]" />
                <ManageAddonsSection optionData={option} />
              </div>
            )}
          </>
        </div>
      </div>
    </div>
  );
}
